const initTabs = (container) => {
    const tabs = container.querySelectorAll('.app-preview__item');
    const tabLinks = container.querySelectorAll('.app-preview__link');
    const tabsTimerDur = 5000;

    const setNextTab = () => {
        const numTabs = tabs.length - 1;
        const curTabPos = Array.from(tabs).findIndex((i) => i.classList.contains('active'));
        const nextTabPos = (curTabPos === numTabs) ? 0 : curTabPos + 1;
        tabs[nextTabPos].querySelector('.app-preview__link').click();
    };

    let tabsTimer = setInterval(() => setNextTab(), tabsTimerDur);

    const resetTabsTimer = () => {
        window.clearTimeout(tabsTimer);
        tabsTimer = setInterval(() => setNextTab(), tabsTimerDur);
    };

    tabLinks.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            resetTabsTimer();
            container.querySelector('.app-preview__item.active').classList.remove('active');
            container.querySelector('.app-preview__pane.previous').classList.remove('previous');
            container.querySelector('.app-preview__pane.active').classList.add('previous');
            container.querySelector('.app-preview__pane.active').classList.remove('active');
            e.target.parentElement.classList.add('active');
            document.querySelector(e.target.hash).classList.add('active');
        });
    });
};

const init = (els) => {
    els.forEach((item) => {
        initTabs(item);
    });
};

export { init as default };
